import { LitElement, html, utils } from '@hh/global.js'
const { prefersReducedMotion } = utils

class HHProductAccordions extends LitElement {
  static get properties() {
    return {
      openIndex: { type: Number, reflect: true, attribute: 'open-index' },
    }
  }

  constructor() {
    super()

    this.openIndex = -1

    this.isShort = true
    this.readMore = this.querySelector('.js-read-more')
    this.readMore?.addEventListener('click', this.toggleReadMore.bind(this))
    this.contents = this.querySelectorAll('.js-accordion-content')
  }

  toggleReadMore() {
    this.isShort = !this.isShort
    if (this.isShort) {
      this.querySelector('.js-product-content-short').style.display = 'block'
      this.querySelector('.js-product-content-long').style.display = 'none'
    } else {
      if (this.readMore) {
        this.readMore.style.display = 'none'
      }
      this.querySelector('.js-product-content-short').style.display = 'none'
      this.querySelector('.js-product-content-long').style.display = 'block'
      this.contents[0].style.maxHeight = this.contents[0].scrollHeight + 'px'
    }
  }

  firstUpdated() {
    const triggers = this.querySelectorAll('.js-accordion-trigger')
    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        if (this.openIndex === index) {
          this.openIndex = -1
        } else {
          this.openIndex = index
        }
        this.requestUpdate()
      })
    })
  }

  updated() {
    const triggers = this.querySelectorAll('.js-accordion-trigger')
    this.contents.forEach((content, index) => {
      if (index === this.openIndex) {
        content.classList.add('open')
        content.style.display = 'block'
        content.style.maxHeight = content.scrollHeight + 'px'
        triggers[index].classList.add('open')
        triggers[index].setAttribute('aria-expanded', true)
      } else {
        content.classList.remove('open')
        content.style.maxHeight = null
        if (prefersReducedMotion()) {
          content.style.display = 'none'
        }

        triggers[index].classList.remove('open')
        triggers[index].setAttribute('aria-expanded', false)
      }
    })
  }

  render() {
    return html` <slot></slot> `
  }
}

customElements.define('hh-product-accordions', HHProductAccordions)
